import React, { useState, useRef, useEffect, UIEvent } from 'react';
import cx from 'classnames';

import styles from './scrollableContainer.module.scss';

interface ScrollableContainerProps {
  children: React.ReactNode;
  className?: string;
}

export const ScrollableContainer: React.FC<ScrollableContainerProps> = ({
  children,
  className
}) => {

  const [showTopShadow, setShowTopShadow] = useState(false);
  const [showBottomShadow, setShowBottomShadow] = useState(false);

  const scrollableRef = useRef<HTMLDivElement>(null);

  const checkScroll = () => {
    const el = scrollableRef.current;
    if (!el) return;

    setShowTopShadow(el.scrollTop > 0);

    const isAtBottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 1; // +1 for pixel-perfect rounding
    setShowBottomShadow(!isAtBottom);
  };

  // The event handler for the onScroll event
  const handleScroll = (event: UIEvent<HTMLDivElement>) => {
    const el = event.currentTarget;
    setShowTopShadow(el.scrollTop > 0);

    const isAtBottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 1;
    setShowBottomShadow(!isAtBottom);
  };

  useEffect(() => {
    checkScroll();
    window.addEventListener('resize', checkScroll);

    return () => {
      window.removeEventListener('resize', checkScroll);
    };
  }, [children]);

  return (
    <div className={cx(styles.shadowContainer, {
      [styles.hasTopShadow]: showTopShadow,
      [styles.hasBottomShadow]: showBottomShadow
    }, className)}>
      <div className={styles.scrollWrapper}>
        <div
          ref={scrollableRef}
          className={styles.scrollableContent}
          onScroll={handleScroll}
        >
          {children}
        </div>
      </div>
    </div>
  );
};
